// components
import input from '@/components/input'

// imask plugin
import IMask from 'imask'

/**
 * @module
 * @name InputNumber
 * @extends Input
 */
export default {
  name: 'InputNumber',
  extends: input,
  /**
   * @property {Object} mask options object to apply to imask.
   */
  data: function () {
    return {
      mask: {}
    }
  },

  /**
   * @property {String} name input name that will be used to differentiate the
   * input among others.
   * @property {Number} floatDigits will be used in the mask to limit the
   * maximum number of digits after radix separator. 0 for integer.
   * @property {String} placeholder Placeholder to show while input is empty.
   */
  props: {
    name: {
      type: String,
      required: false
    },
    floatDigits: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      required: false
    }
  },

  methods: {
    /**
     * This method is used to set mask value when the input's value is modified
     * and sends the corresponding event.
     */
    updateValue (type, event) {
      this.mask.value = event.target.value
      this.$emit(type, this.mask.value)
    }
  },
  mounted () {
    /**
     * Initial vue-imask configuration and initial mask value if any provided.
     */
    const element = document.querySelector(`[name=${this.name}]`)
    const maskOptions = {
      mask: Number,
      scale: this.floatDigits,
      signed: false,
      radix: '.',
      mapToRadix: [',']
    }
    this.mask = IMask(element, maskOptions)
    this.mask.value = this.value.toString()
  }

}
